import { Component } from '@angular/core';
import swal from 'sweetalert2';
import {AuthenticationService} from '../../services/authentication.service'
import {DashboardData,EnvironmentModel,TenantModel,StatsModel,VVModel,VVOperationModel,UsersModel, FormsData} from '../../models/dashboard.model'
declare var $: any;
const misc: any = {
    navbar_menu_visible: 0,
    active_collapse: true,
    disabled_collapse_init: 0,
  };
@Component({
    selector: 'base-cmp',
    templateUrl: 'base.component.html',
})

export class BaseComponent {
    editEntity:any;
    selectedTenant:any
     colors = {
        gray: {
          100: '#f6f9fc',
          200: '#e9ecef',
          300: '#dee2e6',
          400: '#ced4da',
          500: '#adb5bd',
          600: '#8898aa',
          700: '#525f7f',
          800: '#32325d',
          900: '#212529'
        },
        theme: {
          'default': '#172b4d',
          'primary': '#5e72e4',
          'secondary': '#f4f5f7',
          'info': '#11cdef',
          'success': '#2dce89',
          'danger': '#f5365c',
          'warning': '#fb6340'
        },
        black: '#12263F',
        white: '#FFFFFF',
        transparent: 'transparent',
      };
      
    awsregions = [
        {value: 'us-east-1', viewValue: 'US East (N. Virginia)'},
        {value: 'us-east-2', viewValue: 'US East (Ohio)'},
        {value: 'us-west-1', viewValue: 'US West (N. California)'},
        {value: 'us-west-2', viewValue: 'US West (Oregon)'},
        {value: 'ca-central-1', viewValue: 'Canada (Central)'},
        {value: 'eu-west-1', viewValue: 'EU (Ireland)'},
        {value: 'eu-central-1', viewValue: 'EU (Frankfurt)'},
        {value: 'eu-west-2', viewValue: 'EU (London)'},
        {value: 'eu-west-3', viewValue: 'EU (Paris)'},
        {value: 'eu-north-1', viewValue: 'EU (Stockholm)'},
        {value: 'ap-northeast-1', viewValue: 'Asia Pacific (Tokyo)'},
        {value: 'ap-northeast-2', viewValue: 'Asia Pacific (Seoul)'},
        {value: 'ap-southeast-1', viewValue: 'Asia Pacific (Singapore)'},
        {value: 'ap-southeast-2', viewValue: 'Asia Pacific (Sydney)'},
        {value: 'ap-south-1', viewValue: 'Asia Pacific (Mumbai)'},
        {value: 'sa-east-1', viewValue: 'South America (São Paulo)'},
        {value: 'us-gov-west-1', viewValue: 'US Gov West 1'},
        {value: 'us-gov-east-1', viewValue: 'US Gov East 1'}
      ];
      signaturetypes = [
        {value: 'e-signature', viewValue: 'E-Signature'},
        {value: 'docusign', viewValue: 'DocuSign'}
      ];
      locales = [
        {value: 'ach', viewValue: 'Acoli'},
        {value: 'af', viewValue: 'Afrikaans'},
        {value: 'an', viewValue: 'Aragonese'},
        {value: 'ar', viewValue: 'Arabic'},
        {value: 'an', viewValue: 'Aragonese'},
        {value: 'ast', viewValue: 'Asturian'},
        {value: 'az', viewValue: 'Azerbaijani'},
        {value: 'be', viewValue: 'Belarusian'},
        {value: 'bg', viewValue: 'Bulgarian'},
        {value: 'bn', viewValue: 'Bengali'},
        {value: 'bo', viewValue: 'Tibetan'},
        {value: 'br', viewValue: 'Breton'},
        {value: 'bs', viewValue: 'Bosnian'},
        {value: 'ca', viewValue: 'Catalan'},
        {value: 'cak', viewValue: 'Kaqchikel'},
        {value: 'cs', viewValue: 'Czech'},
        {value: 'cy', viewValue: 'Welsh'},
        {value: 'da', viewValue: 'Danish'},
        {value: 'dsb', viewValue: 'Lower Sorbian'},
        {value: 'el', viewValue: 'Greek, Modern'},
        {value: 'en-CA', viewValue: 'English (Canada)'},
        {value: 'en-GB', viewValue: 'English (Great Britain)'},
        {value: 'en-US', viewValue: 'English (US)'},
        {value: 'eo', viewValue: 'Esperanto'},
        {value: 'es-AR', viewValue: 'Spanish (Argentina)'},
        {value: 'es-CL', viewValue: 'Spanish (Chile)	'},
        {value: 'es-ES', viewValue: 'Spanish (Spain)'},
        {value: 'es-MX', viewValue: 'Spanish (Mexico)'},
        {value: 'et', viewValue: 'Estonian'},
        {value: 'eu', viewValue: 'Basque'},
        {value: 'fa', viewValue: 'Persian'},
        {value: 'ff', viewValue: 'Fulah'},
        {value: 'fi', viewValue: 'Finnish'},
        {value: 'fr', viewValue: 'French'},
        {value: 'fy-NL', viewValue: 'Western Frisian'},
        {value: 'ga-IE', viewValue: 'Irish'},
        {value: 'gd', viewValue: 'Gaelic'},
        {value: 'gl', viewValue: 'Galician'},
        {value: 'gn', viewValue: 'Guarani'},
        {value: 'he', viewValue: 'Hebrew'},
        {value: 'hi-IN', viewValue: 'Hindi'},
        {value: 'hr', viewValue: 'Croatian'},
        {value: 'hsb', viewValue: 'Upper Sorbian'},
        {value: 'hu', viewValue: 'Hungarian'},
        {value: 'hye', viewValue: 'Armenian'},
        {value: 'ia', viewValue: 'Interlingua'},
        {value: 'id', viewValue: 'Indonesian'},
        {value: 'is', viewValue: 'Icelandic'},
        {value: 'it', viewValue: 'Italian'},
        {value: 'ja', viewValue: 'Japanese'},
        {value: 'ka', viewValue: 'Georgian'},
        {value: 'kab', viewValue: 'Kabyle'},
        {value: 'kk', viewValue: 'Kazakh'},
        {value: 'km', viewValue: 'Central Khmer'},
        {value: 'kn', viewValue: 'Kannada'},
        {value: 'ko', viewValue: 'Korean'},
        {value: 'lo', viewValue: 'Lao'},
        {value: 'lt', viewValue: 'Lithuanian'},
        {value: 'lv', viewValue: 'Latvian'},
        {value: 'mk', viewValue: 'Macedonian'},
        {value: 'mr', viewValue: 'Marathi'},
        {value: 'ms', viewValue: 'Malay'},
        {value: 'my', viewValue: 'Burmese'},
        {value: 'nb-NO', viewValue: 'Bokmål, Norwegian'},
        {value: 'ne-NP', viewValue: 'Nepali'},
        {value: 'nl', viewValue: 'Dutch; Flemish'},
        {value: 'nn-NO', viewValue: 'Norwegian Nynorsk; Nynorsk, Norwegian'},
        {value: 'oc', viewValue: 'Occitan'},
        {value: 'pa-IN', viewValue: 'Punjabi'},
        {value: 'pl', viewValue: 'Polish'},
        {value: 'pt-BR', viewValue: 'Portuguese'},
        {value: 'rm', viewValue: 'Romansh'},
        {value: 'ro', viewValue: 'Romanian; Moldavian; Moldovan'},
        {value: 'ru', viewValue: 'Russian'},
        {value: 'scn', viewValue: 'Sicilian'},
        {value: 'si', viewValue: 'Sinhalese'},
        {value: 'sk', viewValue: 'Slovak'},
        {value: 'sl', viewValue: 'Slovenian'},
        {value: 'som', viewValue: 'Somali'},
        {value: 'sq', viewValue: 'Albanian'},
        {value: 'sv-SE', viewValue: 'Swedish'},
        {value: 'ta', viewValue: 'Tamil'},
        {value: 'te', viewValue: 'Telugu'},
        {value: 'th', viewValue: 'Thai'},
        {value: 'tl', viewValue: 'Tagalog'},
        {value: 'tr', viewValue: 'Turkish'},
        {value: 'uk', viewValue: 'Ukrainian'},
        {value: 'ur', viewValue: 'Urdu'},
        {value: 'uz', viewValue: 'Uzbek'},
        {value: 'vi', viewValue: 'Vietnamese'},
        {value: 'wo', viewValue: 'Wolof'},
        {value: 'xh', viewValue: 'Xhosa'},
        {value: 'zh-CN', viewValue: 'Chinese'},
        {value: 'zh-TW', viewValue: 'Chinese(Taiwan)'}
      ];
    constructor(protected authenticationService:AuthenticationService ){
        if(this.isLoggedIn())
            this.authenticationService.setIsLoggedIn(true);
    }
    dashboardData:DashboardData;
    alertdisplayed:boolean = false;
    getClientName()
    {
        const currentUser = JSON.parse(sessionStorage.getItem('vvuser'));
        if(currentUser)
            return currentUser.client;
        else
            return '';
    }
    isRootUser()
    {
        const currentUser = JSON.parse(sessionStorage.getItem('vvuser'));
        if(currentUser)
            return currentUser.root;
        else
            return false;
    }
    isNull(prop)
  {
    if(prop == '' || prop == undefined)
    return true;
    else
    return false;
  }

    isLoggedIn()
    {
        const currentUser = JSON.parse(sessionStorage.getItem('vvuser'));
        return currentUser?true:false;
    }
    showTimeoutPop(message:string){
        if(!this.alertdisplayed){
            this.alertdisplayed=true;
        swal({
          title: 'Timeout Warning',
          text: message,
          type: 'warning',
          showCancelButton: true,
          cancelButtonText:"Logout",
          confirmButtonClass: 'btn btn-success',
          cancelButtonClass: 'btn btn-danger',
          confirmButtonText: "Stay",
           buttonsStyling: false
        }).then((result) => {
            this.alertdisplayed=false;
            if(result.value)
                this.authenticationService.setTimeOut(false);
            else
            this.authenticationService.setTimeOut(false);
        })
    }
  }
    showMessageWithTitle(type,title,message) { 
        if (type == 'info') {
        swal({
            title: title,
            text: message,
            buttonsStyling: false,
            confirmButtonClass: "btn btn-info"
        }).catch(swal.noop)
        }
        else if (type == 'success') {
            swal({
                title: title,
                text: message,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-success",
                type: "success"
            }).catch(swal.noop)
  
        } 
        else if (type == 'error') {
            swal({
                title: title,
                text: message,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger",
                type: "error"
            }).catch(swal.noop)
  
        } 
        else if (type == 'warning') {
            swal({
                title: title,
                text: message,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-warning",
                type: "error"
            }).catch(swal.noop)
  
        } 
    }
    showAutoCloseAlert(title:string,message:string)
    {
            swal({
                title: title,
                text: message,
                timer: 2000,
                showConfirmButton: false
            }).catch(swal.noop)
    }
    showMessage(type,message) {        
      if (type == 'success') {
          swal({
              title: message,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-success"
          }).catch(swal.noop)

      } else if (type == 'info') {
        swal({
            title: message,
            buttonsStyling: false,
            confirmButtonClass: "btn btn-info"
        }).catch(swal.noop)
      }else if (type == 'warning') {
        swal({
            title: message,
            buttonsStyling: false,
            confirmButtonClass: "btn btn-warning"
        }).catch(swal.noop)
      }   
      else if (type == 'error') {
        swal({
            title: message,
            buttonsStyling: false,
            confirmButtonClass: "btn btn-danger"
        }).catch(swal.noop)
      }   
    }
     showConfirmationMsg(confirmText:string,callback,entity){
          swal({
            title: 'Confirm Action',
            text: confirmText,
            type: 'warning',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-success',
            cancelButtonClass: 'btn btn-danger',
            confirmButtonText: "Confirm",
             buttonsStyling: false
          }).then((result) => {              
              callback(result,this.editEntity,this.authenticationService,entity);
            //return result.value;
          })
    }
    showConfirmationMsg1(confirmText:string,callback,additinalFunction,list){
        swal({
          title: 'Confirm Action',
          text: confirmText,
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success',
          cancelButtonClass: 'btn btn-danger',
          confirmButtonText: "Confirm",
           buttonsStyling: false
        }).then((result) => {              
            callback(result,this.editEntity,this.authenticationService,additinalFunction,list);
          //return result.value;
        })
  }
  showConfirmationMsg2(confirmText:string,callback,additinalFunction,object1,object2){
    swal({
      title: 'Confirm Action',
      text: confirmText,
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-success',
      cancelButtonClass: 'btn',
      confirmButtonText: "Confirm",
       buttonsStyling: false
    }).then((result) => {              
        callback(result,this.editEntity,this.authenticationService,additinalFunction,object1,object2);
      //return result.value;
    })
}
      showCustomHTMLPop(title:string,html:string)
      {
            swal({
                title: title,
                customClass:'largepop',
                buttonsStyling: false,
                confirmButtonClass: "btn btn-success",
                html: html
            }).catch(swal.noop)
    }
    showCustomInputPop(title:string)
    {

            swal({
                title: title,
                html: '<div class="form-group">' +
                    '<input id="input-field" type="text" class="form-control" />' +
                    '</div>',
                showCancelButton: true,
                confirmButtonClass: 'btn btn-success',
                cancelButtonClass: 'btn btn-danger',
                buttonsStyling: false
            }).then(function(result) {
                return $('#input-field').val();
            }).catch(swal.noop)
        }
        processDashboardCustomResponse(result){
            let stats:StatsModel = new StatsModel();
            stats.deserialize(result.range);
            stats.type='All';
            this.dashboardData.stats.push(stats);
        }
    processDashboardResponse(result)
    {
        this.dashboardData = new DashboardData();
        this.dashboardData.clientMeta.deserialize(result);
        this.authenticationService.setViewerUrlInSession(this.dashboardData.clientMeta.viewer_url);
        let tenants:TenantModel[] = [];
        for (let t in result.tenants){
        let tenant:TenantModel = new TenantModel();
        tenant.deserialize(result.tenants[t]);
        let environments:EnvironmentModel[] = [];
        for (let e in result.tenants[t].envs){
            let env:EnvironmentModel = new EnvironmentModel();
            env.deserialize(result.tenants[t].envs[e],this.dashboardData.clientMeta.theme);
            if(tenant.active =="No")
                env.active="No";
            environments.push(env);
        }
        tenant.environments = environments;
        tenant.totalenvironments=environments.length
        tenants.push(tenant);
        }
        this.dashboardData.tenants = tenants;
        this.processDashboardCustomResponse(result.status);
    }
    processUsers(result)
    {
        let users:UsersModel[] = [];
        for (let e in result){
            let user:UsersModel = new UsersModel();
            user.deserialize(result[e]);
            let usertenants:TenantModel[] = [];
            user.usertype="Admin";
            for (let t in result[e].tenants){
                user.usertype="Regular";
                let tenant:TenantModel = new TenantModel();
                tenant.deserialize(result[e].tenants[t]);
                usertenants.push(tenant);
            }
            user.tenants=usertenants;
            users.push(user);
        }
        return users;
    }
    getVVModelForActivateDeactivate(entitytype:string,entity:VVModel)
    {
        if(entitytype == 'tenant'){
            let vvModel = new VVModel();
            vvModel.tenant=entity.name;
            vvModel.inactive=entity.inactive;
            return vvModel;
        }
        else if (entitytype == 'environment'){
            let environment = entity as EnvironmentModel;
            let env:VVModel = new VVModel();
            env.env=environment.name;
            env.tenant=environment.tenant;
            env.inactive=entity.inactive;
            return env;
        }
    }
    getVVModelForSave(entity:any,operation:string)
    {
        let vvOperationModel = new VVOperationModel();
            let vvModel = new VVModel();
            vvOperationModel.theme="Classic";
            vvModel.tenant=entity.name;
            if(entity.timout)
                vvModel.timeout=entity.timeout;
            else if(entity.envtimeout)
            vvModel.timeout=entity.envtimeout;
            vvModel.requested=entity.requestprivates3;
            if(entity.active)
                vvModel.active=entity.active;
            if(operation=="add")
                vvModel.active="yes";
            if(entity.envname)
                vvModel.env=entity.envname;
            if(!vvModel.requested)
            {
                if(entity.s3_access_id)
                    vvModel.s3_access_id=entity.s3_access_id;
                if(entity.s3_secret_access_key)
                    vvModel.s3_secret_access_key=entity.s3_secret_access_key;
                if(entity.s3_region)
                    vvModel.s3_region=entity.s3_region;
                if(entity.s3_bucket_name)
                vvModel.s3_bucket_name=entity.s3_bucket_name;
            }
             if(entity.roles)
                vvModel.roles=entity.roles;
            else
            {
                let roles=[];
                vvModel.roles=roles;
            }
             return vvModel;
    }
    getFormDataForSave(form:any,tenant:TenantModel,env:string,primaryRoles:any[],secondaryRoles:any[],signatureType:string)
    {
         let formsData = new FormsData();
         formsData.formname=form.formname;
         formsData.template_id=form.template_id;
         
         var roles:string[]=[];
         for (let t in primaryRoles){
            roles.push(primaryRoles[t]);
         }
         for (let t in secondaryRoles){
            roles.push(secondaryRoles[t]);
         }
         formsData.roles=roles;
         formsData.tenant_id=tenant.tenant;
         formsData.env=env;
         if(signatureType == 'docusign')
            formsData.docusign=true;
        else
            formsData.docusign=false;
         formsData.client_id=this.getClientId();
         var orders:string[][]=[];
         orders.push(primaryRoles);
         for (let t in secondaryRoles){
            var roleArr:string[] =[];
            roleArr.push(secondaryRoles[t]);
            orders.push(roleArr);
         }
         formsData.signing_order=orders;
          return formsData;
    }
    getVVModelToSaveGlobalTheme(tenant:string,environments:any,theme:string)
    {
        let vvModel = new VVModel();
        vvModel.tenant=tenant;
        vvModel.theme=theme;
        return vvModel;
    }
    getVVModelToSaveTheme(tenant:string,environments:any,theme:string)
    {       
            let vvModelArr = [];
            for (let t in environments){
                let vvModel = new VVModel();
                vvModel.tenant=tenant;
                vvModel.env=environments[t];
                vvModel.theme=theme;
                vvModelArr.push(vvModel);
            }
            return vvModelArr;
    }
    getEnvironmentsForTenant(name)
    {
        this.selectedTenant = this.dashboardData.tenants.find( function( tenant ){
            return tenant.name === name;
          } );
        if(this.selectedTenant)
        return this.selectedTenant.environments;
        else
        return []
    }
    getTenantFromName(name)
    {
        return this.dashboardData.tenants.find( function( tenant ){
            return tenant.name === name;
          } );
    }
    redirectToLogin() {
        sessionStorage.clear();
        window.location.href = "#/auth/login?refresh=1";
      }
      minimizeSidebar(){
        const body = document.getElementsByTagName('body')[0];
        {
            setTimeout(function() {
                body.classList.add('sidebar-mini');
    
                misc.sidebar_mini_active = true;
            }, 300);
        }
    
        // we simulate the window Resize so the charts will get updated in realtime.
        const simulateWindowResize = setInterval(function() {
            window.dispatchEvent(new Event('resize'));
        }, 180);
    
        // we stop the simulation of Window Resize after the animations are completed
        setTimeout(function() {
            clearInterval(simulateWindowResize);
        }, 1000);
      }
      getClientId()
    {
      if(this.dashboardData)
        return this.dashboardData.clientMeta.client_id;
    }
    getName(email)
    {
        if(email!= undefined && email != '' && email != null)
        return email.substring(0, email.lastIndexOf("@"));
        else    
            return "";
    }
    compareToSort(ob1,ob2) {
        if (ob1.name < ob2.name)
          return -1;
        if (ob1.name > ob2.name)
          return 1;
        return 0;
      }
      compareSort(a: number | string, b: number | string, isAsc: boolean) {
        return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
      }
}
